import type { AccountHealthLevel } from './api';

export const HEALTH_COLORS: Record<AccountHealthLevel, string> = {
  critical: '#ef4444',
  warning: '#f59e0b',
  healthy: '#10b981',
  inactive: '#9ca3af',
};

export const HEALTH_LABELS: Record<AccountHealthLevel, string> = {
  critical: 'Crítico',
  warning: 'Atención',
  healthy: 'Saludable',
  inactive: 'Inactivo',
};

export const PHONE_ANALYTICS_VIEW = {
  GENERAL_SUMMARY: 'general-summary',
  OUTBOUND_HISTORY: 'outbound-history',
  INBOUND_HISTORY: 'inbound-history',
  ABANDONED_CALLS: 'abandoned-calls',
} as const;

export type PhoneAnalyticsView = typeof PHONE_ANALYTICS_VIEW[keyof typeof PHONE_ANALYTICS_VIEW];

/** Role IDs used by Interstellar for user permissions */
export const USER_ROLE = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  AGENT: 3,
} as const;

export type UserRoleId = typeof USER_ROLE[keyof typeof USER_ROLE];

/** Role labels for display */
export const USER_ROLE_LABELS: Record<number, string> = {
  [USER_ROLE.SUPER_ADMIN]: 'Super admin',
  [USER_ROLE.ADMIN]: 'Admin',
  [USER_ROLE.AGENT]: 'Agente',
};

/** Common input field class names for user modals */
export const USER_MODAL_INPUT_CLASS =
  'w-full rounded-md border px-3 py-2 text-sm transition-colors border-white-2.0 bg-white-0.0 text-black-1.0 placeholder-gray-1.0 focus:border-primary-2.0 focus:outline-none focus:ring-1 focus:ring-primary-2.0';

/** Extract error message from Axios-like errors */
export const getApiErrorMessage = (err: unknown, fallback: string): string => {
  const axiosErr = err as { response?: { data?: { detail?: string; message?: string } } };
  const detail = axiosErr?.response?.data?.detail || axiosErr?.response?.data?.message;
  return typeof detail === 'string' && detail.length > 0 ? detail : fallback;
};
